import { Box, Typography } from '@mui/material';
import { TournamentBracketMatchGameStatus } from '@okletsplay/core';
import { BracketSeedMatchGameEntity } from 'app/interfaces/entity';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { TextInput } from 'shared/components/Form/TextInput';
import { URL_WITH_PROTOCOL_REGEX } from 'shared/utils';
import { CodeSourceKey } from '../CodeSourceKey';

interface ComponentProps {
  matchGame: BracketSeedMatchGameEntity;
  sourceKey: CodeSourceKey;
}

export const MatchGameCodeInput: FC<ComponentProps> = ({ matchGame, sourceKey }) => {
  const title = useMemo(() => {
    if (!matchGame) {
      return '';
    }
    return `Game ${Number(matchGame.number)}`;
  }, [matchGame]);

  const isMatchGameExpired = useMemo(() => {
    if (!matchGame?.status) {
      return false;
    }

    return (
      [
        TournamentBracketMatchGameStatus.Archived,
        TournamentBracketMatchGameStatus.Completed,
      ].includes(matchGame.status) || matchGame.isExpired
    );
  }, [matchGame.isExpired, matchGame.status]);

  const code = useMemo(() => matchGame[sourceKey] ?? '', [matchGame, sourceKey]);

  const [isUrl, setIsUrl] = useState(false);

  useEffect(() => {
    try {
      setIsUrl(URL_WITH_PROTOCOL_REGEX.test(code));
    } catch {
      setIsUrl(false);
    }
  }, [code]);

  if (!matchGame) {
    return null;
  }

  return (
    <Box>
      <Box display="flex" pb={1}>
        <Typography variant="subtitle1" color="text.secondary">
          {title}
        </Typography>
        {isMatchGameExpired && (
          <Typography pl={1} variant="subtitle1" color="error.light">
            (Expired)
          </Typography>
        )}
      </Box>
      <TextInput value={code} readOnly isCopyOnClick withCopy={!isUrl} withOpen={isUrl} />
    </Box>
  );
};
